import React from 'react'
import { Col, Input, Row } from 'antd'
import StoreSelect from 'Components/StoreSelect'
import SupplierSelect from 'Components/SupplierSelect'
import AgreementStateSelect from 'Components/AgreementStateSelect'
import { MarginBottonContainer } from 'Common/styled'

import { userType } from 'Common/constants'
import FormItem from '../FormItem'

const AgreementTableFilter = props => (
  <MarginBottonContainer>
    <Row gutter={16}>
      {/* Show supplier filter only if user is not supplier */}
      {props.user.type !== userType.S.key && (
        <Col span={6}>
          <FormItem label="Fornitore">
            <SupplierSelect
              suppliers={props.suppliers}
              value={props.filter.supplierId}
              onChange={val => props.onChangeCallback({ supplierId: val })}
            />
          </FormItem>
        </Col>
      )}
      <Col span={6}>
        <FormItem label="Stato accordo">
          <AgreementStateSelect
            states={props.states}
            value={props.filter.state}
            onChange={val => props.onChangeCallback({ state: val })}
          />
        </FormItem>
      </Col>
      {props.user.type === userType.FIN.key && (
        <React.Fragment>
          <Col span={6}>
            <FormItem label="Negozi">
              <StoreSelect
                stores={props.stores}
                value={props.filter.storeId}
                onChange={val => props.onChangeCallback({ storeId: val })}
              />
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem label="Numero DDT">
              <Input
                allowClear
                placeholder="Inserisci un DDT"
                value={props.filter.ddt}
                onChange={e => props.onChangeCallback({ ddt: e.target.value })}
              />
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem label="Numero BDS">
              <Input
                allowClear
                placeholder="Inserisci un BDS"
                value={props.filter.bds}
                onChange={e => props.onChangeCallback({ bds: e.target.value })}
              />
            </FormItem>
          </Col>
        </React.Fragment>
      )}
    </Row>
  </MarginBottonContainer>
)
export default AgreementTableFilter



// WEBPACK FOOTER //
// ./src/components/AgreementTableFilter/index.js